import { I18N_NS } from "Config/i18n";
import { Modal } from "Components/General/Modal/GenericModal";
import { Trans, useTranslation } from "react-i18next";
import { accessRightColors } from "./AcessRightsCell";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useMemo } from "react";

export const AccessRightsExplanation = () => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const accessRightsInfo = [
    t("V = VIEW - No download possible, only view via viewer (optional)"),
    t("D = READ WITH WATERMARK - Download only with watermark"),
    t("R = READ - Download"),
    t("W = WRITE - Upload, download, overwrite or archive own files"),
    t("O = OWNER - Upload or overwrite all (also files of others) files"),
    t(`X = OWNER+DIRECTORY - Create directories (like O, plus managing sub directories)`),
    t("Rights apply to the respective subfolders until rights are set there."),
  ];
  const accessRightsColorInfo = [
    [t("No Errors"), accessRightColors.ACCESS],
    [t("Set right will not work (error)"), accessRightColors.CONFLICT],
    [t("Set right might not work as intended (warning)"), accessRightColors.SUSPICIOUS],
    [t("Recent change being processed"), accessRightColors.UPDATED],
  ];
  const [visible, setVisible] = useState(false);
  const rightsItems = useMemo(() => accessRightsInfo.map((item, idx) => <li key={idx}>{item}</li>), []);
  const colorInfo = useMemo(
    () =>
      accessRightsColorInfo.map((item, idx) => {
        return (
          <div key={idx}>
            <div
              style={{
                display: "inline-block",
                border: "1px solid #ccc",
                marginRight: 5,
                width: 50,
                height: 23,
                backgroundColor: item[1],
              }}
            />
            <div style={{ display: "inline-block" }}>{item[0]}</div>
          </div>
        );
      }),
    []
  );

  const toggleModal = () => {
    setVisible(!visible);
  };

  return (
    <>
      <span className="pointer" onClick={toggleModal}>
        <FontAwesomeIcon fixedWidth size="2x" icon={["far", "question-circle"]} />
      </span>
      <Modal title={t("Help")} footer={null} onCancel={toggleModal} width={800} zIndex={1051} open={visible}>
        <ul style={{ paddingLeft: 10 }}>{rightsItems}</ul>
        <Trans ns={I18N_NS.PROJECT}>
          <h3>Context menu:</h3>
          <p>With a right-click on one of the rows you will get the following options:</p>
          <ul style={{ paddingLeft: 10 }}>
            <li>Expand: Opens that folder and shows its contents.</li>
            <li>Collapse: Closes that folder and hides its contents.</li>
            <li>Expand all subfolders: Opens that folder and every subfolder on every level below.</li>
            <li>Collapse all subfolders: Closes all subfolders of that folder.</li>
          </ul>
        </Trans>
        <div style={{ paddingLeft: 10, marginTop: 20 }}>{colorInfo}</div>
      </Modal>
    </>
  );
};
